import { FaStar } from "react-icons/fa"
import { RiDeleteBin6Line } from "react-icons/ri"
import { useDispatch, useSelector } from "react-redux"

import { removeFromCart } from "../../../../slices/cartSlice"

export default function RenderCartCourses() {
  const { cart } = useSelector((state) => state.cart)
  const dispatch = useDispatch()

  return (
    <div className="flex flex-col gap-4">
      {cart.map((course) => {
        const avgRating =
          course?.ratingAndReviews?.length
            ? (
                course.ratingAndReviews.reduce((sum, r) => sum + r.rating, 0) /
                course.ratingAndReviews.length
              ).toFixed(1)
            : "4.5"
        const reviewCount = course?.ratingAndReviews?.length ?? 0

        return (
          <div
            key={course._id}
            className="flex flex-col gap-4 rounded-2xl border border-richblack-700 bg-richblack-800 p-4 transition-all hover:border-richblack-600 sm:flex-row sm:items-start"
          >
            {/* Thumbnail */}
            <img
              src={course?.thumbnail}
              alt={course?.courseName}
              className="h-[140px] w-full rounded-xl object-cover sm:h-[110px] sm:w-[180px] flex-shrink-0"
            />

            {/* Info */}
            <div className="flex flex-1 flex-col justify-between gap-3 min-w-0">
              <div>
                <p className="line-clamp-2 text-sm font-semibold text-richblack-5 leading-snug">
                  {course?.courseName}
                </p>
                <p className="mt-1 text-xs text-richblack-400">
                  {course?.category?.name}
                </p>
              </div>

              {/* Rating */}
              <div className="flex items-center gap-1.5">
                <span className="text-xs font-semibold text-yellow-50">{avgRating}</span>
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <FaStar
                      key={star}
                      size={11}
                      className={
                        star <= Math.round(Number(avgRating))
                          ? "text-yellow-50"
                          : "text-richblack-500"
                      }
                    />
                  ))}
                </div>
                <span className="text-xs text-richblack-400">
                  ({reviewCount} {reviewCount === 1 ? "rating" : "ratings"})
                </span>
              </div>
            </div>

            {/* Price + Remove */}
            <div className="flex flex-row items-center justify-between sm:flex-col sm:items-end sm:justify-between gap-3 flex-shrink-0">
              <p className="text-xl font-bold text-yellow-50">
                ₹{course?.price?.toLocaleString("en-IN")}
              </p>
              <button
                onClick={() => dispatch(removeFromCart(course._id))}
                className="flex items-center gap-1.5 rounded-lg border border-richblack-600 bg-richblack-700 px-3 py-1.5 text-xs font-medium text-pink-300 transition-all hover:border-pink-400/40 hover:bg-richblack-600 hover:text-pink-200 active:scale-95"
              >
                <RiDeleteBin6Line size={13} />
                Remove
              </button>
            </div>
          </div>
        )
      })}
    </div>
  )
}
